import { Search, Table, FileCheck, UserPlus } from "lucide-react";

const steps = [
  {
    icon: UserPlus,
    step: "1",
    title: "Faça seu cadastro",
    description: "O cadastro é simples, rápido e leva apenas alguns minutos.",
  },
  {
    icon: Search,
    step: "2",
    title: "Faça sua busca",
    description:
      "Digite o serviço ou produto que deseja consultar na barra de pesquisa.",
  },
  {
    icon: Table,
    step: "3",
    title: "Analise os resultados",
    description:
      "Veja as alíquotas IBS/CBS, códigos CST e classificações tributárias.",
  },
  //   {
  //     icon: FileCheck,
  //     step: "3",
  //     title: "Use as informações",
  //     description: "Aplique os dados nas suas notas fiscais e declarações.",
  //   },
];

export const HowItWorks = () => {
  return (
    <section className="py-12 scroll-mt-20" id="howitwork">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-foreground mb-2">
            Como Funciona
          </h2>
          <p className="text-muted-foreground">
            Consulte dados tributários em 3 passos simples
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative bg-card border-1 border-border-tail rounded-xl p-6 text-center hover:border-primary-tail/50 transition-all duration-300 group animate-fade-up"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Step number badge */}
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-6 h-6 rounded-full bg-primary-tail text-primary-tail-foreground text-xs font-bold flex items-center justify-center">
                {step.step}
              </div>

              {/* Icon */}
              <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-primary-tail/10 flex items-center justify-center group-hover:bg-primary-tail/20 transition-colors">
                <step.icon className="w-6 h-6 text-primary-tail" />
              </div>

              {/* Content */}
              <h3 className="font-semibold text-foreground mb-2">
                {step.title}
              </h3>
              <p className="text-sm text-muted-foreground">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
